import script from "./HeaderLacen.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLacen.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLacen.vue?vue&type=style&index=0&id=51cc6af0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51cc6af0"]])

export default __exports__